/**
 * Dev Console 顶层路由（/dev-console）· W2-9 PR-1 mock 基础设施骨架
 *
 * 承接：
 * - CLAUDE.md §11.5.1 数据工厂落 admin /dev-console 子页
 * - 项目基础规范 §1.8 PM 验证场景集
 *
 * 路由层级：与 /debug（M01）平级独立顶层路由（不嵌在 M01 下，因为数据工厂是基础设施跨模块复用）
 *
 * 可见性：
 * - dev/staging：nav 链接显示（VITE_DEV_CONSOLE_ENABLED=1 注入）
 * - prod：链接隐藏 + 路由仍可达（用户输入 URL 也能进，但后端 /admin/v1/dev/* gate 返 404 防误用）
 */
import { createFileRoute } from "@tanstack/react-router";

import { DevConsoleShell } from "@/components/dev-console/dev-console-shell";

export const Route = createFileRoute("/dev-console")({
	component: DevConsolePage,
});

function DevConsolePage() {
	return (
		<div className="space-y-4">
			<header>
				<h2 className="text-xl font-semibold">Dev Console · 数据工厂 / Mock 模式</h2>
				<p className="mt-1 text-sm text-text-secondary">
					离线/无后端时用 mock 数据驱动验证的开发工具 · 仅开发与预发环境可见
				</p>
			</header>
			<DevConsoleShell />
		</div>
	);
}
